import { BlurGate } from "@/components/guest"
import { CommentList } from "@/features/comments/components/CommentList"

interface DiscussionSectionProps {
  entityId: string
  canComment: boolean
  canReply?: boolean
  canModerate: boolean
  canNotifyMembers?: boolean
  isGuest?: boolean
}

export function DiscussionSection({
  entityId,
  canComment,
  canReply,
  canModerate,
  canNotifyMembers = false,
  isGuest = false,
}: DiscussionSectionProps) {
  const content = (
    <div id="discussion">
      <CommentList
        entityType="ritual"
        entityId={entityId}
        canComment={canComment}
        canReply={canReply}
        canModerate={canModerate}
        canNotifyMembers={canNotifyMembers}
        isGuest={isGuest}
      />
    </div>
  )

  if (isGuest) {
    return <BlurGate ctaVariant="comments">{content}</BlurGate>
  }

  return content
}
